import { PaymentAccount, StatusObj } from '@amfam/shared/models';
import { Option } from '@amfam/ui-kit';

export interface OneTimePaySetup {
  billAccountNumber?: string;
  riskDescription?: string;
  policyTypeIcon?: string;
  paymentAmount?: string;
  helpText?: HelpText;
  paymentAccountId?: string | number;
  paymentDate?: string;
  text?: string;
  dueDate?: string;
  accountBalance?: string;
  minDue?: string;
  pastDue?: boolean;
  useNickNameAsTitle?: boolean;
  paymentAccount?: PaymentAccount;
  selectedPaymentAccountType?: string;
  selectedPaymentAccount?: string;
  selectedPaymentDate?: string;
  selectedPaymentAmount?: number;
  scheduledPaymentId?: string; // This would be set in case of edit scheduled payment
  alertMessage?: AlertMessage;
  accountType?: string;
  isCancellationLetterSent?: boolean;
  paymentTerm?: string;
  iframeToken?: string;
  cardDetails?: string;
  frequency?: string;
}
export interface HelpText {
  text: string;
  warning?: boolean;
  errorText?: string;
}

export interface TotalAmount {
  dollars: string;
  cents: string;
}

export interface ChoosePaymentAmountModal {
  radioButtonOptions: Option[];
  accountDescriptionDetails: OneTimePaySetup;
}
export interface OTPReviewData {
  billAccountNumber: string;
  selectedPaymentAccount: string;
  selectedPaymentDate: string;
  selectedPaymentAmount: number;
  scheduledPaymentId?: string; // This would be set in case of edit scheduled payment
}

export interface AlertMessage {
  title: string;
  heading: string;
  body1?: string;
  body2?: unknown;
  body2Text?: string;
  body3?: string;
  billAccountNumber: string;
  amount?: string;
  date?: string;
  dueDate?: string;
  dueDateMulti?: string;
  error?: boolean;
  warningText?: string;
}
export interface OTPAnalyticsModel {
  pageAnalyticName?: string;
  pageAnalyticSubCategory3?: string;
  buttonAnalyticName?: string;
  eventName?: string;
  paymentAmount?: string;
  paymentDate?: string;
}

// payment error codes which are payment method errors
export const PaymentMethodRelatedPaymentErrorCodes = ['400002', '400003', '500003'];

// payment error codes upon which user cannot take any action
export const NotModifiablePaymentErrorCodes = ['400000', '403002', '404005'];

export interface AccountForSimplifiedPayment {
  nickName: string;
  isSelected: boolean;
  id: string;
  isDisabled?: boolean;
  pillStatus: StatusObj;
  policyRiskIconList: string[];
  riskDescription: string;
  paymentOptions: PaymentOption[];
  dueDate: string;
  accountType: string;
  isCancellationLetterSent: boolean;
  pastDue: boolean;
  alertMessage?: AlertMessage;
  selectedPaymentAmount?: string;
  radioFieldErrorMessage?: string;
  linkedAccountIcon?: string;
  minDue: string;
  isRomeNew?: boolean;
  isRomeOld?: boolean;
  icon?: string;
}
export interface PaymentOption {
  amount: string;
  id: string;
  text: string;
}

export const MY_NATIVE_DATE_FORMATS = {
  display: {
    dateInput: 'MMM DD, YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

export interface simplifiedPaymentReviewData {
  selectedBillAccounts?: simplifiedPaymentReviewAccount[];
  paymentMethodNickName?: string;
  paymentDate: string;
  totalAmount?: number;
  confirmationHeading?: string;
  paymentTerm?: string;
  iframeToken?: string;
  policyNumber?: string;
  cardDetails?: string;
}

export interface simplifiedPaymentReviewAccount {
  billAccountNumber?: string;
  nickName: string;
  risk: string;
  amount: number;
}
